<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md6>
        <v-combobox
          v-model="selectedProduct"
          :items="$store.state.products.all"
          item-value="id"
          item-text="name"
          @change="onProductChange"
          hide-details
          label="Ana Ürün Seçiniz"
          :disabled="isEdit"
        ></v-combobox>
        <v-text-field v-model="mpProduct.mpSku" label="Marketplace SKU" :counter="max" required></v-text-field>
        <v-text-field v-model="mpProduct.formula" label="Özel Formül" :counter="max"></v-text-field>
        <v-text-field v-model="mpProduct.price" label="Satış Fiyatı" :counter="max" required type="number" step="0.01"></v-text-field>
        <v-text-field v-model="mpProduct.listPrice" label="Liste Fiyatı" :counter="max" required type="number" step="0.01"></v-text-field>
        <v-text-field v-model="mpProduct.purchasePrice" label="Alış Fiyatı" :counter="max" required type="number" step="0.01"></v-text-field>
      </v-flex>

      <v-flex xs12 md6>
        <v-text-field v-model="mpProduct.stock" label="Stok Adedi" :counter="max" required type="number"></v-text-field>
        <v-switch v-model="mpProduct.onSale" :label="`Satışta: ${mpProduct.onSale ? 'Evet' : 'Hayır'}`"></v-switch>
        
        <!-- Ana ürün bilgileri (sadece görüntüleme) -->
        <v-card v-if="selectedProduct && selectedProduct.id" class="mt-4" outlined>
          <v-card-title class="subtitle-1">Ana Ürün Bilgileri</v-card-title>
          <v-card-text>
            <v-text-field v-model="selectedProduct.sku" label="Ana SKU" readonly></v-text-field>
            <v-text-field v-model="selectedProduct.name" label="Ana Ürün Adı" readonly></v-text-field>
            <v-text-field v-model="selectedProduct.brand" label="Marka" readonly></v-text-field>
            <v-text-field v-model="selectedProduct.price" label="Ana Fiyat" readonly></v-text-field>
            <v-text-field v-model="selectedProduct.availableStock" label="Ana Stok" readonly></v-text-field>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12>
        <v-btn color="success" @click="saveMpProduct" :loading="saveLoading">Kaydet</v-btn>
        <v-btn color="primary" @click="goBack" class="ml-2">Geri</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    selectedProduct: {},
    alert: false,
    saveLoading: false,
    max: 255,
    isEdit: false,
    mpProduct: {
      id: 0,
      productId: 0,
      mpSku: '',
      formula: '',
      price: 0,
      listPrice: 0,
      purchasePrice: 0,
      stock: 0,
      onSale: true
    }
  }),

  computed: {
    productId() {
      return this.$route.params.id;
    }
  },

  async created() {
    // Ana ürünleri yükle
    await this.$store.dispatch("products/getAllProducts");
    
    if (this.productId) {
      this.isEdit = true;
      await this.loadMpProduct();
    } else {
      // Yeni ürün için varsayılan değerler
      this.mpProduct = {
        id: 0,
        productId: 0,
        mpSku: '',
        formula: '',
        price: 0,
        listPrice: 0,
        purchasePrice: 0,
        stock: 0,
        onSale: true
      };
    }
  },

  methods: {
    async loadMpProduct() {
      try {
        const mpProduct = await this.$store.dispatch("mpProducts/getMpProduct", this.productId);
        this.mpProduct = { ...mpProduct };
        
        // Ana ürünü seç
        if (mpProduct.productId) {
          this.selectedProduct = this.$store.state.products.all.find(p => p.id === mpProduct.productId) || {};
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('MP Product yüklenirken hata:', error);
      }
    },

    onProductChange() {
      if (this.selectedProduct && this.selectedProduct.id) {
        this.mpProduct.productId = this.selectedProduct.id;
        
        // Ana ürün bilgilerinden varsayılan değerleri çek
        if (!this.isEdit) {
          this.mpProduct.mpSku = this.selectedProduct.sku;
          this.mpProduct.formula = this.selectedProduct.formula || '';
          this.mpProduct.price = this.selectedProduct.price || 0;
          this.mpProduct.listPrice = this.selectedProduct.listPrice || 0;
          this.mpProduct.purchasePrice = this.selectedProduct.purchasePrice || 0;
          this.mpProduct.stock = this.selectedProduct.availableStock || 0;
        }
      }
    },

    async saveMpProduct() {
      if (!this.selectedProduct || !this.selectedProduct.id) {
        alert('Lütfen bir ana ürün seçin!');
        return;
      }

      if (!this.mpProduct.mpSku) {
        alert('Marketplace SKU zorunludur!');
        return;
      }

      this.saveLoading = true;
      try {
        this.mpProduct.productId = this.selectedProduct.id;
        
        if (this.isEdit) {
          await this.$store.dispatch("mpProducts/putMpProduct", this.mpProduct);
        } else {
          await this.$store.dispatch("mpProducts/postMpProduct", this.mpProduct);
        }
        
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.goBack();
        }, 2000);
        
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Kaydetme hatası:', error);
        alert('Kaydetme sırasında hata oluştu!');
      } finally {
        this.saveLoading = false;
      }
    },

    goBack() {
      this.$router.push('/mpproduct');
    }
  },

  watch: {
    // Ana ürün fiyatı değiştiğinde MP fiyatını güncelle (sadece yeni ürünlerde)
    'selectedProduct.price'(newVal) {
      if (!this.isEdit && newVal) {
        this.mpProduct.price = newVal;
        this.mpProduct.listPrice = newVal;
      }
    },
    'selectedProduct.purchasePrice'(newVal) {
      if (!this.isEdit && newVal) {
        this.mpProduct.purchasePrice = newVal;
      }
    }
  }
};
</script>

